import kvSlider from './top/kvSlider';
import kvModal from './top/kvModal';
import brandTab from './top/brandTab';
import coordinateSlide from './top/coordinateSlide';
import splashMot from './top/splash';

export default class topManager {
    constructor(effect,util,param) {

        this.effect = effect;

        this.loaded = false;

        this.splash = new splashMot(effect,util,param);

        this.kvSlider = new kvSlider();
        this.kvModal = new kvModal(param,this.kvSlider);
        this.brandTab = new brandTab();
        this.coordinateSlide = new coordinateSlide();

    }
    init(scroll,mouse){

        this.splash.init()

        this.kvSlider.init(scroll)
        this.kvModal.init(scroll,mouse,this.splash)
        this.brandTab.init()
        this.coordinateSlide.init()

        setTimeout(()=>{
            this.splash.show(scroll)
        });

        setTimeout(()=>{
            this.loaded = true;
        },5e3);


        const _$navi = document.querySelectorAll('.header-nav__item')

        for(let i in _$navi){

            if (_$navi[i].nodeType != 1) break

            _$navi[i].addEventListener("click",(e)=>{

                for(let j in _$navi) {
                    if (_$navi[j].nodeType != 1) continue
                    _$navi[j].classList.remove("is-current")
                }

                scroll.selectTo(e.target.getAttribute("data-target"))

            })

        }


        let _$svgBtn = document.querySelectorAll(".js__svg-btn")
        let _mouseEnter = false



        for(let i in _$svgBtn){

            if (_$svgBtn[i].nodeType != 1) break

            _$svgBtn[i].addEventListener('mousemove', e => {
                // console.log("enter")
                if(_mouseEnter) return;
                _mouseEnter = true;
                // this._sliderCtrlMouseEnter(e.target)
                TweenMax.to(
                    e.target.querySelectorAll('.js__write'),
                    0.4,
                    {
                        drawSVG: '100%',
                        ease: Power2.easeIn,
                        onComplete:()=>{
                        }

                    }
                )

            })

            _$svgBtn[i].addEventListener('mouseleave', e => {
                if(!_mouseEnter) return;
                _mouseEnter = false;

                TweenMax.to(
                    e.target.querySelectorAll('.js__write'),
                    0.4,
                    {
                        drawSVG: '0%',
                        ease: Power2.easeIn,
                        onComplete:()=>{
                        }

                    }
                )


            })

        }



    }
    render(mouse,scrollInc){

        this.splash.render();

        if(this.loaded) this.kvSlider.render(this.kvModal.status.mode);
        if(this.loaded) this.coordinateSlide.render();

    }
    resize(w,h,deviceSize){

    }
}